/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's Ajax API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {}
}

/*============================================================================
  DOM / HTTP helpers
==============================================================================*/
function getData($el, key) {
  const value = $el.dataset[key]
  if (value === undefined) return undefined
  if (/^-?\d+$/.test(value)) return parseInt(value, 10)
  return value
}

function findSibling($el, selector) {
  const $parent = $el.parentElement
  if (!$parent) return null
  return (
    Array.from($parent.children).find(function ($child) {
      return $child !== $el && $child.matches(selector)
    }) || null
  )
}

function shopifyRequest(url, options) {
  options = options || {}
  const method = options.method || 'GET'
  const headers = Object.assign({}, options.headers || {})
  const fetchOptions = { method, headers }

  if (options.body !== undefined && options.body !== null) {
    if (typeof options.body === 'string') {
      fetchOptions.body = options.body
      if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    } else {
      fetchOptions.body = JSON.stringify(options.body)
      headers['Content-Type'] = 'application/json'
    }
  }

  return fetch(url, fetchOptions).then(function (response) {
    return response.text().then(function (text) {
      let data = {}
      if (text) {
        try {
          data = JSON.parse(text)
        } catch (error) {
          data = { message: text }
        }
      }

      if (!response.ok) {
        const xhr = { responseText: text }
        throw xhr
      }

      return data
    })
  })
}

function parseErrorResponse(xhr) {
  try {
    return JSON.parse(xhr.responseText)
  } catch (error) {
    return {}
  }
}

function parseBundleIds(bundleValue) {
  if (!bundleValue) return []
  return String(bundleValue)
    .split(',')
    .map(function (bundleId) {
      return bundleId.trim()
    })
    .filter(Boolean)
}

function mergeParentBundleIds(existingBundles, bundleId) {
  const bundles = parseBundleIds(existingBundles)
  if (!bundles.includes(bundleId)) {
    bundles.push(bundleId)
  }
  return bundles.join(',')
}

function getParentVariantIdFromBundle(bundleId, upsellVariantId) {
  const upsellVariantIdString = String(upsellVariantId)
  if (!bundleId || !bundleId.endsWith(upsellVariantIdString)) return null
  return bundleId.slice(0, bundleId.length - upsellVariantIdString.length)
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += ''
    if (attribute === 'undefined') {
      attribute = ''
    }
  }
  return attribute.trim()
}

function toObject(object_string) {
  const parameters = {}
  let elements

  if (!object_string) {
    return {}
  }

  elements = object_string.split('&')

  elements.forEach((element) => {
    const equals_index = element.indexOf('=')
    if (equals_index == -1) {
      parameters[decodeURIComponent(element)] = null
    } else {
      const key = decodeURIComponent(element.slice(0, equals_index))
      const value = decodeURIComponent(element.slice(equals_index + 1)) || null
      parameters[key] = value
    }
  })

  return parameters
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  console.log('onCartUpdate', cart)
}

ShopifyAPI.updateCart = function (sections) {
  if (!sections) return

  shopifyRequest(`${window.shop_api.routes.root}?sections=${sections}`)
    .then(function (data) {
      ShopifyAPI.refreshCart(data)
      document.body.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: data }))
    })
    .catch(function (xhr) {
      ShopifyAPI.onError(xhr, 'error')
    })
}

ShopifyAPI.updateCartNote = function (note, callback) {
  shopifyRequest(`${window.shop_api.routes.cart_update_url}`, {
    method: 'POST',
    body: 'note=' + attributeToString(note),
  })
    .then(function (cart) {
      if (typeof callback === 'function') {
        callback(cart)
      } else {
        ShopifyAPI.onCartUpdate(cart)
      }
    })
    .catch(function (xhr) {
      ShopifyAPI.onError(xhr, 'error')
    })
}

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  const data = parseErrorResponse(XMLHttpRequest)
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description)
  }
}

const cartSections = {
  cart: '#CartContainer',
  'cart-modals': '#CartUpsellModalContainer',
  'cart-count': '#CartCount',
}

const renderCartSections = (sections) => {
  for (const name in sections) {
    document.querySelectorAll(cartSections[name]).forEach((entry) => {
      entry.innerHTML = sections[name]
    })
  }
}

ShopifyAPI.refreshCart = function (sections) {
  renderCartSections(sections)
}

ShopifyAPI.swapItem = function (key, id, quantity, properties) {
  const data = {
    id: key,
    quantity: 0,
    sections: 'cart,cart-modals,cart-count',
  }

  fetch(window.shop_api.routes.cart_change_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Swap items success:', data)
      ShopifyAPI.addItemById(id, quantity, properties)
    })
    .catch((error) => {
      console.error('updateItem error:', error)
    })
}

ShopifyAPI.removeItemByKey = function (key) {
  const data = {
    id: key,
    quantity: 0,
    sections: 'cart,cart-modals,cart-count',
  }

  fetch(window.shop_api.routes.cart_change_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Update items success:', data)
      ShopifyAPI.refreshCart(data.sections)
    })
    .catch((error) => {
      console.error('updateItem error:', error)
    })
}

ShopifyAPI.addItemById = function (id, quantity, properties) {
  const data = {
    items: [
      {
        id,
        quantity,
        properties,
      },
    ],
    sections: 'cart,cart-modals,cart-count',
  }

  fetch(window.shop_api.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      console.log('Add item success:', data)
      ShopifyAPI.refreshCart(data.sections)
    })
    .catch((error) => {
      console.error('addItem error:', error)
    })
}

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

let productBundle
let upsellProducts

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  const upsellProductsData = upsellProducts(form)

  const data = new FormData(form)
  const formData = Object.fromEntries(data)
  const properties = {}

  for (const key of data.keys()) {
    if (key.startsWith('properties')) {
      properties[key.replace('properties[', '').replace(']', '')] = formData[key]
    }
  }

  const items = {
    items: [
      {
        id: formData.id,
        quantity: formData.quantity,
        properties: properties,
        // TryNow TBYB: carry the selling plan injected on the form so the item is added as Try Before You Buy
        selling_plan: formData.selling_plan || undefined,
      },
    ],
  }

  if (upsellProductsData) {
    upsellProductsData.forEach(function (upsell) {
      items.items.unshift({
        id: upsell.id,
        quantity: 1,
        properties: {
          _add_on_parent: `${formData['product-id']}`,
          _add_on_discount: upsell.discount,
        },
        // TryNow TBYB: if the main item is added as Try Before You Buy and this upsell has its own Try selling plan, add the upsell as TBYB too
        selling_plan: formData.selling_plan && upsell.sellingPlan ? upsell.sellingPlan : undefined,
      })
    })
  }

  shopifyRequest(`${window.shop_api.routes.cart_add_url}?sections=cart,cart-modals`, {
    method: 'POST',
    body: items,
  })
    .then(function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form, line_item.sections.cart, line_item.sections['cart-modals'])
      } else {
        ShopifyAPI.onItemAdded(line_item, form)
      }
    })
    .catch(function (xhr) {
      console.info('ERROR', xhr)
      if (typeof errorCallback === 'function') {
        errorCallback(xhr, 'error')
      } else {
        ShopifyAPI.onError(xhr, 'error')
      }
    })
}

ShopifyAPI.addItemFromButton = function (
  upsellVariantId,
  parentVariantId,
  parentProductId,
  callback,
  errorCallback,
  discountPercent,
  sellingPlan
) {
  const $parentQtyInput = document.querySelector(
    `#CartDrawer .ajaxcart__qty input[type="number"][data-id="${parentVariantId}"]`
  )
  const parentQuantity = parseInt($parentQtyInput?.value, 10)

  if (!Number.isInteger(parentQuantity) || parentQuantity <= 0) {
    console.info('ERROR', 'Invalid parent cart line or quantity')
    const xhr = {
      responseText: JSON.stringify({
        message: 'Cart error',
        status: 422,
        description: 'Unable to add item. Please refresh and try again.',
      }),
    }
    if (typeof errorCallback === 'function') {
      errorCallback(xhr, 'error')
    } else {
      ShopifyAPI.onError(xhr, 'error')
    }
    return
  }

  shopifyRequest(`${window.shop_api.routes.cart_add_url}?sections=cart,cart-modals`, {
    method: 'POST',
    body: {
      quantity: parentQuantity,
      id: upsellVariantId,
      properties: {
        _add_on_parent: parentProductId.toString(),
        _add_on_discount: discountPercent == '' ? null : discountPercent,
      },
      // TryNow TBYB: add this cart upsell as Try Before You Buy when its Try selling plan was provided by the button
      selling_plan: sellingPlan || undefined,
    },
  })
    .then(function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item, null, line_item.sections.cart, line_item.sections['cart-modals'])
      } else {
        ShopifyAPI.onCartUpdate(line_item)
      }
      return line_item
    })
    .catch(function (xhr) {
      if (typeof errorCallback === 'function') {
        errorCallback(xhr, 'error')
      } else {
        ShopifyAPI.onError(xhr, 'error')
      }
    })
}

ShopifyAPI.getCart = function (callback) {
  shopifyRequest(`${window.shop_api.routes.cart_url}`)
    .then(function (cart) {
      if (typeof callback === 'function') {
        callback(cart)
      } else {
        ShopifyAPI.onCartUpdate(cart)
      }
    })
    .catch(function (xhr) {
      ShopifyAPI.onError(xhr, 'error')
    })
}

ShopifyAPI.changeItem = function (line, quantity, callback) {
  shopifyRequest(`${window.shop_api.routes.cart_change_url}?sections=cart,cart-modals`, {
    method: 'POST',
    body: 'quantity=' + quantity + '&line=' + line,
  })
    .then(function (cart) {
      if (typeof callback === 'function') {
        callback(cart, cart.sections.cart, cart.sections['cart-modals'])
      } else {
        ShopifyAPI.onCartUpdate(cart)
      }
    })
    .catch(function (xhr) {
      ShopifyAPI.onError(xhr, 'error')
    })
}

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module) {
  'use strict'

  let init, loadCart, quickAddItem

  let settings, isUpdating
  let $body, $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer

  let updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    validateQty,
    validateBundle,
    validateCart,
    bundleQuantity,
    reduceBundledQuantity,
    buildCartSection,
    refreshCartModals

  init = function (options) {
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
    }

    Object.assign(settings, options)

    $formContainer = document.querySelector(settings.formSelector)
    $cartContainer = document.querySelector(settings.cartContainer)
    $addToCart = document.querySelector(`${settings.formSelector} ${settings.addToCartSelector}`)
    $cartCountSelector = settings.cartCountSelector
      ? document.querySelector(settings.cartCountSelector)
      : null
    $cartCostSelector = settings.cartCostSelector ? document.querySelector(settings.cartCostSelector) : null

    $body = document.body
    isUpdating = false

    formOverride()
    adjustCart()
    validateCart()
  }

  productBundle = function () {
    const $$bundleInputs = Array.from(document.querySelectorAll('.js-uspPromo__variant-checkbox'))

    const checkedInput = $$bundleInputs.filter(function (input) {
      return input.checked
    })

    if (checkedInput[0]) {
      return {
        variantId: checkedInput[0].dataset.variantId,
        variantTitle: checkedInput[0].dataset.variantTitle,
        variantLineAttribute: checkedInput[0].dataset.attribute,
      }
    }
  }

  upsellProducts = function (form) {
    const $$upsellInputs = Array.from(form.querySelectorAll('[data-add-on]'))

    if ($$upsellInputs) {
      return $$upsellInputs
        .map((input) => {
          if (input.checked) {
            const inputId = input.dataset.addOn
            const upsellDiscount = input.dataset.addOnDiscount == '' ? null : input.dataset.addOnDiscount
            const upsellSellingPlan = input.dataset.addOnSellingPlan || null
            const selectedVariant = form.querySelector(`[data-upsell-variant-input="${inputId}"]:checked`).value
            return {
              id: selectedVariant,
              discount: upsellDiscount,
              sellingPlan: upsellSellingPlan,
            }
          } else {
            return null
          }
        })
        .filter((input) => input !== null)
    } else {
      return false
    }
  }

  quickAddItem = function (upsellVariantId, parentVariantId, parentProductId, discountPercent, sellingPlan) {
    ShopifyAPI.addItemFromButton(
      upsellVariantId,
      parentVariantId,
      parentProductId,
      itemAddedCallback,
      itemErrorCallback,
      discountPercent,
      sellingPlan
    )
  }

  loadCart = function () {}

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.innerHTML = cart.item_count
      $cartCountSelector.classList.remove('hidden-count')

      if (cart.item_count === 0) {
        $cartCountSelector.classList.add('hidden-count')
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.innerHTML = Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }
  }

  formOverride = function () {
    const $$forms = document.querySelectorAll(settings.formSelector)
    $$forms.forEach(function ($form) {
      $form.addEventListener('submit', function (evt) {
        if (!evt.target.action.includes('/cart/add')) return

        evt.preventDefault()

        if ($addToCart) {
          $addToCart.classList.remove('is-added')
          $addToCart.classList.add('is-adding')
        }

        document.querySelectorAll('.qty-error').forEach(function ($error) {
          $error.remove()
        })

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback)
      })
    })
  }

  itemAddedCallback = function (product, form, cartSection, cartModals) {
    if ($addToCart) {
      $addToCart.classList.remove('is-adding')
      $addToCart.classList.add('is-added')
    }
    buildCartSection(cartSection)
    refreshCartModals(cartModals)
    document.body.dispatchEvent(
      new CustomEvent('ajaxCart.afterCartLoad', { detail: { openDrawer: true } })
    )
    ShopifyAPI.getCart(cartUpdateCallback)
    console.log('ITEM ADDED CALLBACK')
  }

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    const data = parseErrorResponse(XMLHttpRequest)
    if ($addToCart) {
      $addToCart.classList.remove('is-adding', 'is-added')
    }

    if (!!data.message) {
      if (data.status == 422 && $formContainer) {
        $formContainer.insertAdjacentHTML(
          'afterend',
          '<div class="errors qty-error">' + data.description + '</div>'
        )
      }
    }
  }

  buildCartSection = function (cartSection) {
    if ($cartContainer) {
      $cartContainer.innerHTML = cartSection
    }
  }

  refreshCartModals = function (cartModals) {
    const $modalContainer = document.querySelector('#CartUpsellModalContainer')
    if ($modalContainer) {
      $modalContainer.innerHTML = cartModals
    }
  }

  cartUpdateCallback = function (cart) {
    const event = new CustomEvent('cart:change', { detail: cart })
    document.dispatchEvent(event)
    updateCountPrice(cart)
    cartCallback(cart)
  }

  cartCallback = function (cart) {
    $body.classList.remove('drawer--is-loading')
    document.body.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: cart }))

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart)

      const $$moneyEls = Array.from(document.querySelectorAll('.js-container-bundle-dropdown .money'))

      $$moneyEls.forEach(function ($money) {
        if ($money.childNodes[1]) {
          $money.childNodes[1].remove()
        }
      })
      console.log('cartCallback bold', true)
    }

    setTimeout(function () {
      validateBundle(cart)
      bundleQuantity(cart)
    }, 500)
  }

  adjustCart = function () {
    $body.addEventListener('click', function (e) {
      const $el = e.target.closest('.ajaxcart__qty-adjust')
      if (!$el || $el.classList.contains('js-ajax-bundle-qty-adjust')) return

      const line = getData($el, 'line')
      const $qtySelector = findSibling($el, '.ajaxcart__qty-num, .js-ajax-bundle-update')
      let qty = parseInt(($qtySelector?.value || '').replace(/\D/g, ''), 10)

      qty = validateQty(qty)

      if ($el.classList.contains('ajaxcart__qty--plus')) {
        qty += 1
      } else {
        qty -= 1
        if (qty <= 0) qty = 0
      }

      if (line) {
        updateQuantity(line, qty)
        e.preventDefault()
      } else if ($qtySelector) {
        $qtySelector.value = qty
      }
    })

    $body.addEventListener('input', function (e) {
      const $el = e.target.closest('.ajaxcart__qty-num')
      if (!$el) return

      document.querySelectorAll('.cart__checkout').forEach(function ($checkout) {
        $checkout.disabled = true
      })

      const line = getData($el, 'line')
      let qty = parseInt(($el.value || '').replace(/\D/g, ''), 10)
      qty = validateQty(qty)

      if (line) {
        updateQuantity(line, qty)
      } else {
        document.querySelectorAll('.cart__checkout').forEach(function ($checkout) {
          $checkout.disabled = false
        })
      }
    })

    $body.addEventListener('submit', function (evt) {
      const $form = evt.target.closest('form.ajaxcart')
      if (!$form) return
      if (isUpdating) {
        evt.preventDefault()
      }
    })

    $body.addEventListener('focus', function (e) {
      const $el = e.target.closest('.ajaxcart__qty-adjust')
      if (!$el || typeof $el.select !== 'function') return
      setTimeout(function () {
        $el.select()
      }, 50)
    }, true)

    function updateQuantity(line, qty) {
      isUpdating = true

      const $row = document.querySelector('.ajaxcart__row[data-line="' + line + '"]')
      if ($row) {
        $row.classList.add('is-loading')
      }

      if (qty === 0 && $row?.parentElement) {
        $row.parentElement.classList.add('is-removed')
      }

      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback)
      }, 250)
    }

    $body.addEventListener('input', function (e) {
      const $el = e.target.closest('.js-ajax-bundle-update')
      if (!$el) return
      removeBundleItem($el)
    })

    $body.addEventListener('click', function (e) {
      const $el = e.target.closest('.js-ajax-bundle-qty-adjust')
      if (!$el) return
      adjustBundleItem($el)
    })

    const adjustBundleItem = function ($el) {
      const line = getData($el, 'line')
      const bundleID = getData($el, 'bundle')
      const key = getData($el, 'key')
      const $qtySelector = findSibling($el, '.js-ajax-bundle-update')
      let qty = parseInt(($qtySelector?.value || '').replace(/\D/g, ''), 10)
      qty = validateQty(qty)

      if ($el.classList.contains('ajaxcart__qty--plus')) {
        qty += 1
      } else {
        qty -= 1
        if (qty <= 0) qty = 0
      }

      if (line && key && qty === 0) {
        shopifyRequest(`${window.shop_api.routes.cart_json}`)
          .then(function (cart) {
            const items = cart.items
            const bundleIDs = parseBundleIds(bundleID)
            const childItems = items.filter(function (item) {
              return item.properties && bundleIDs.includes(item.properties['_bundle'])
            })
            const update_items = {}
            update_items[key] = qty

            childItems.forEach(function (item) {
              update_items[item.key] = 0
            })

            return shopifyRequest(window.shop_api.routes.cart_update_url, {
              method: 'POST',
              body: { updates: update_items },
            })
          })
          .then(function (cart) {
            adjustCartCallback(cart)
          })
      } else if (line) {
        updateQuantity(line, qty)
      } else if ($qtySelector) {
        $qtySelector.value = qty
      }
    }

    const removeBundleItem = function ($el) {
      document.querySelectorAll('.cart__checkout').forEach(function ($checkout) {
        $checkout.disabled = true
      })

      const line = getData($el, 'line')
      const bundleID = getData($el, 'bundle')
      const key = getData($el, 'key')
      let qty = parseInt(($el.value || '').replace(/\D/g, ''), 10)
      qty = validateQty(qty)

      if (line && key) {
        shopifyRequest(`${window.shop_api.routes.cart_json}`)
          .then(function (cart) {
            const items = cart.items
            const bundleIDs = parseBundleIds(bundleID)
            const childItems = items.filter(function (item) {
              return item.properties && bundleIDs.includes(item.properties['_bundle'])
            })
            const update_items = {}
            update_items[key] = qty

            childItems.forEach(function (item) {
              const childitem_qty = item.quantity
              if (qty < childitem_qty && qty > 0) {
                update_items[item.key] = qty
              } else if (qty == 0) {
                update_items[item.key] = 0
              }
            })

            return shopifyRequest(window.shop_api.routes.cart_update_url, {
              method: 'POST',
              body: { updates: update_items },
            })
          })
          .then(function (cart) {
            adjustCartCallback(cart)
          })
      }
    }

    bundleQuantity = function () {
      const $$cartItemElements = Array.from(
        document.querySelectorAll('.ajaxcart__qty-num, .js-ajax-bundle-update')
      )

      if (!$$cartItemElements.length) return

      const $$bundleChildrenElements = $$cartItemElements.filter(function ($el) {
        return $el.getAttribute('properties')
      })

      if (!$$bundleChildrenElements.length) return

      $$bundleChildrenElements.forEach(function ($bundledInput) {
        const MainInputElements = $$cartItemElements.filter(function ($el) {
          const $parent = $el.closest('.ajaxcart__product')?.querySelector('.js-ajax-bundle-update')
          const $child = $bundledInput.closest('.ajaxcart__product')?.querySelector('.ajaxcart__qty-num')
          const parentBundles = parseBundleIds($parent?.dataset.bundle)
          return (
            !$el.getAttribute('properties') &&
            $parent &&
            $child &&
            parentBundles.includes($child.getAttribute('properties'))
          )
        })

        const $bundledItemIncrementBtn = $bundledInput.parentElement.querySelector('.ajaxcart__qty--plus')
        const bundledItemsQuantity = parseInt($bundledInput.value, 10)

        let MainItemTotalQuantity = 0
        MainInputElements.forEach(function ($el) {
          MainItemTotalQuantity += parseInt($el.value, 10)
        })

        if (MainItemTotalQuantity === bundledItemsQuantity) {
          $bundledItemIncrementBtn.disabled = true
          $bundledItemIncrementBtn.classList.add('is-disabled')
        } else if (MainItemTotalQuantity < bundledItemsQuantity && MainItemTotalQuantity > 0) {
          $bundledItemIncrementBtn.disabled = true
          $bundledItemIncrementBtn.classList.add('is-disabled')
          reduceBundledQuantity($bundledInput, MainItemTotalQuantity, bundledItemsQuantity)
        } else if (MainItemTotalQuantity === 0 && MainInputElements.length > 0) {
          const $checkoutBtn = document.querySelector('.ajaxcart__footer .cart__checkout')
          if ($checkoutBtn) {
            $checkoutBtn.disabled = true
            $checkoutBtn.classList.add('is-disabled')
          }
          reduceBundledQuantity($bundledInput, MainItemTotalQuantity, bundledItemsQuantity)
        } else if (MainItemTotalQuantity === 0) {
          return
        } else {
          $bundledItemIncrementBtn.disabled = false
          $bundledItemIncrementBtn.classList.remove('is-disabled')
        }
      })
    }

    reduceBundledQuantity = function ($bundledInput, MainItemTotalQuantity, bundledItemsTotalQuantity) {
      const bundledItemDataLine = $bundledInput.dataset.line
      const bundledInputQuantity = parseInt($bundledInput.value, 10)
      const quantityToAdjust = MainItemTotalQuantity - (bundledItemsTotalQuantity - bundledInputQuantity)

      $bundledInput.value = quantityToAdjust

      ShopifyAPI.changeItem(bundledItemDataLine, quantityToAdjust, adjustCartCallback)
    }

    validateBundle = function (cart) {
      const bundledChildren = cart.items.filter(function (item) {
        return item.properties && item.properties._bundle
      })

      if (!bundledChildren.length) return

      bundledChildren.forEach(function (product) {
        const bundleId = product.properties._bundle
        const hasParentBundle = cart.items.some(function (item) {
          return parseBundleIds(item.properties?._parent).includes(bundleId)
        })

        if (hasParentBundle) return

        const parentVariantId = getParentVariantIdFromBundle(bundleId, product.variant_id)
        const parentInCart = parentVariantId
          ? cart.items.some(function (item) {
              return String(item.variant_id) === parentVariantId && !item.properties?._bundle
            })
          : false

        if (parentInCart) return

        const $childInput = document.querySelector(
          `#CartDrawer .ajaxcart__qty-num[properties="${bundleId}"]`
        )
        if (!$childInput) return

        const line = getData($childInput, 'line')
        if (line) updateQuantity(line, 0)
      })
    }

    validateCart = function () {
      const $$cartItems = Array.from(document.querySelectorAll('.productItem'))

      if (!$$cartItems.length) return

      const $$domBundleProducts = $$cartItems.filter(function ($product) {
        return $product.dataset.properties
      })

      if (!$$domBundleProducts.length) return

      $$domBundleProducts.forEach(function ($bundleProduct) {
        const requiredItems = $$cartItems.filter(function ($product) {
          const parentBundles = parseBundleIds($product.dataset.bundle)
          return parentBundles.includes($bundleProduct.dataset.properties)
        })

        if (!requiredItems.length) $bundleProduct.querySelector('.remove a')?.click()

        const adjust = function (total) {
          const bundleItemsQuantity = +$bundleProduct.querySelector('.quantity input').value
          let requiredItemsQuantity = +requiredItems[0].querySelector('.quantity input').value

          if (total) requiredItemsQuantity = total

          if (bundleItemsQuantity >= requiredItemsQuantity) {
            const $domBundleItem = $bundleProduct.querySelector('input')
            const quantityToAdjust = bundleItemsQuantity - (bundleItemsQuantity - requiredItemsQuantity)

            $domBundleItem.value = quantityToAdjust
          }
        }

        const recalculateCart = function () {
          setTimeout(() => {
            const $$updatedCartItems = Array.from(document.querySelectorAll('.productItem'))
            if (!$$updatedCartItems.length) return

            const updatedRequiredItems = $$updatedCartItems.filter(function ($product) {
              const parentBundles = parseBundleIds($product.dataset.bundle)
              return parentBundles.includes($bundleProduct.dataset.properties)
            })

            const requiredItemsQuantity = +updatedRequiredItems[0].querySelector('.quantity input').value

            adjust(requiredItemsQuantity)
          }, 300)
        }

        $$cartItems.forEach(function ($item) {
          $item.querySelector('input')?.addEventListener('input', recalculateCart)
        })

        adjust()
      })
    }

    $body.addEventListener('change', function (e) {
      const $textarea = e.target.closest('textarea[name="note"]')
      if (!$textarea) return
      ShopifyAPI.updateCartNote($textarea.value, function () {})
    })
  }

  adjustCartCallback = function (cart, cartSection, cartModals) {
    const event = new CustomEvent('cart:change', { detail: cart })
    document.dispatchEvent(event)
    isUpdating = false

    document.querySelectorAll('.cart__checkout').forEach(function ($checkout) {
      $checkout.disabled = false
    })

    updateCountPrice(cart)

    setTimeout(function () {
      ShopifyAPI.getCart(cartUpdateCallback)
      buildCartSection(cartSection)
      refreshCartModals(cartModals)
    }, 150)
  }

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      qty = 1
    }
    return qty
  }

  module = {
    init: init,
    load: loadCart,
    quickAdd: quickAddItem,
  }

  return module
})(ajaxCart || {})
